import React, { PropTypes } from 'react';
import PointItem from './PointItem';

const ZoneItem = ({ id, zone }) => {
  const renderPoints = () => {
    if (zone.points.length) {
      return (
        <div>
          {zone.points.map(p => (
            <PointItem key={p.id} point={p} />
          ))}
        </div>
      );
    }
    return <div className="ui message">Aucun poste associé à cette zone</div>;
  };

  return (
    <div className="ui segment basic">
      <div className="ui segment">
        <strong>{zone.name}</strong>
        <a
          href={`/pco-manager/aast/zones/${zone.id}/plan`}
          className="ui floated right labeled icon button"
        >
          <i className="icon unhide" />
          Visualiser le plan
        </a>
      </div>
      {renderPoints()}
    </div>
  );
};

ZoneItem.propTypes = {
  zone: PropTypes.object.isRequired,
};

export default ZoneItem;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/ZoneItem.js